
// 全局页面跳转是否启用loading
export const routerLoading = true;

// 全局api接口调用是否启用loading
export const apiLoading = true;

// loading参数配置
export const loadingConfig = {
  lock: true,
  text: 'Loading',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
};

// loading组件
import { Loading } from 'element-ui';
var loading = null;
// loading组件显示
const loadingShow = () => {
  loading = Loading.service(loadingConfig);
  return loading;
};
// loading组件隐藏
const loadingHide = () => {
  loading.close();
};
// 输出显示、隐藏
export const glo_loading = {
  loadingShow,
  loadingHide
};

let loadingCount = 0;
// 全局api接口调用loading隐藏
export const apiLoadingShow = () => {
  if (apiLoading && loadingCount === 0) { // 如果全局启用页面跳转则加载loading
    loadingShow();
  }
  loadingCount++;
};
// 全局api接口调用loading显示
export const apiLoadingHide = () => {
  loadingCount--;
  window.setTimeout(() => {
    if (apiLoading && loadingCount === 0) {
      loadingHide();// 关闭loading层
    }
  }, 50);
};
